import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atelierSulphurpoolLight } from 'react-syntax-highlighter/dist/cjs/styles/hljs';
import styled from 'styled-components';
const DocsPageContentCode = ({ fontSize = 12.5, children }) => {
    return React.createElement(DocsPageContentCodeWrapper, { children: children, language: 'text', style: atelierSulphurpoolLight, fontSize: fontSize });
};
export default DocsPageContentCode;
const DocsPageContentCodeWrapper = styled(SyntaxHighlighter) `
  display: inline !important;

  margin-right: 3px !important;
  padding: 1px 5px !important;

  font-size: ${props => props.fontSize}px !important;

  border-radius: 4px;
`;
//# sourceMappingURL=DocsPageContentCode.js.map